import {GlobalVariables} from "../GlobalVariables";
// import Header from "./Header";

export default class NavsFull {
	constructor() {
		this.header = document.querySelector(".header-main");

		if (this.header) {
			this.toggleMobileNav();

			document.addEventListener("escape.pressed", () => {
				this.closeMobileNav();
			});

		}
	}

	toggleMobileNav() {
		const openTrigger = this.header.querySelector(".nav-main-toggle");
        const overlay = this.header.querySelector(".page-overlay");

		if (openTrigger) {
			openTrigger.addEventListener("click", () => {
				if (document.body.classList.contains("navs-open")) {
					this.closeMobileNav();
				} else {
					this.openMobileNav();
				}
			});
		}

        if (overlay) {
            overlay.addEventListener("click", () => {
                this.closeMobileNav();
            });
        }
	}

	openMobileNav() {
		document.body.classList.add("navs-open");
		// GlobalVariables.lenis?.stop();
	}

	closeMobileNav() {
		document.body.classList.remove("navs-open");
		// GlobalVariables.lenis?.start();
	}
}
